/* @flow */
/**
 * Redux Toolkit slice for hamburger navigation state and menu options.
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appConfig from '../../appConfig';
import menuListOptions from '../../constants/menuObject';

const name = 'Hamburger';

function createInitialState() {
  return {
    openHamburger: false,
    closeHamburger: false,
    menuListOptions: []
  };
}

export const initialState = createInitialState();

/**
 * Updates whether the hamburger menu is open.
 */
function openHamburger(state: Object, action: Object) {
  return {
    ...state,
    openHamburger: action.payload
  };
}

/**
 * Updates whether the hamburger menu is closed.
 */
function closeHamburger(state: Object, action: Object) {
  return {
    ...state,
    closeHamburger: action.payload
  };
}

/**
 * Stores the menu options available to the current user.
 */
function fetchMenuListOptions(state: Object, action: Object) {
  return {
    ...state,
    menuListOptions: action.payload
  };
}

/**
 * Collects the hamburger slice reducers.
 */
function createReducers() {
  // OPEN_HAMBURGER
  return {
    openHamburger,
    closeHamburger,
    fetchMenuListOptions
  };
}

export const reducers = createReducers();
export const slice = createSlice({ name, initialState, reducers });

const actions = { ...slice.actions };

/**
 * Returns menu options filtered for the supplied user group.
 */
function getMenuListForUserGroup(group) {
  // GEO users do not have access to the Upload menu entry.
  if (group === appConfig.userGroups.geo) {
    return menuListOptions.filter((menu) => menu.name !== 'Upload');
  }
  return menuListOptions;
}

/**
 * Creates a thunk that reads the authenticated user group and stores permitted menu options.
 */
function getMenuList() {
  return createAsyncThunk(
    `${name}/getMenuList`,
    async (_, { dispatch, getState }) => {
      const state = getState();
      const group = state.auth.userDetails?.group;
      dispatch(actions.fetchMenuListOptions(getMenuListForUserGroup(group)));
    }
  );
}

/**
 * Instantiates async hamburger actions exposed by the slice.
 */
function createExtraActions() {
  return {
    getMenuList: getMenuList()
  };
}

export const extraActions = createExtraActions();

export const hamburgerActions = { ...actions, ...extraActions };
export const hamburgerReducer = slice.reducer;
